export default __webpack_public_path__ + "static/media/one_or_more.0498e456.gif";